'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = visitorContext;

var _immutable = require('immutable');

var _RequestState = require('../lib/RequestState');

var RequestState = _interopRequireWildcard(_RequestState);

var _VisitorContextActionTypes = require('../actionTypes/VisitorContextActionTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var INITIAL_STATE = new _immutable.Map({
  requestState: RequestState.NOT_REQUESTED
});

function visitorContext() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments[1];
  var type = _ref.type;

  switch (type) {
    case _VisitorContextActionTypes.REQUEST_VISITOR_CONTEXT:
      return state.set('requestState', RequestState.REQUESTED);
    case _VisitorContextActionTypes.SUCCEED_GETTING_VISITOR_CONTEXT:
      return state.set('requestState', RequestState.SUCCEEDED);
    case _VisitorContextActionTypes.FAIL_GETTING_VISITOR_CONTEXT:
      return state.set('requestState', RequestState.FAILED);
    default:
      return state;
  }
}
module.exports = exports['default'];